module.exports = __webpack_public_path__ + "img/登陆按钮@2x.fcb6f459.png";